import React, { useEffect, useState } from "react";
import "./NewsStand.css";
import logoDefault from "../../assets/images/amtex_logo.png";
import ClickableNewsList from "../../components/NewsList/ClickableNewsList";
import Loading from "../../components/Loading/Loading";

import { fetchClientClippings } from "../../services/api/fetchClipping";
import { fetchClientsDetails } from "../../services/api/fetchClients";

function NewsStand() {
  const [data, setData] = useState({
    results: [],
    next: null,
    previous: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const today = new Date();
  const formattedDate = today.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const [brand, setBrand] = useState(null);

  useEffect(() => {
    const loadClientDetails = async () => {
      try {
        const details = await fetchClientsDetails();
        setBrand(details || null);
      } catch (err) {
        console.error("Erro ao carregar brand:", err);
        setBrand(null);
      }
    };

    loadClientDetails();
  }, []);

  const loadClippings = async (params = {}) => {
    try {
      setIsLoading(true);
      const response = await fetchClientClippings(params);
      setData({
        results: response.results || [],
        next: response.next,
        previous: response.previous,
      });
    } catch (error) {
      console.error("Erro ao carregar clippings:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    loadClippings({
      date_start: today,
      date_end: today,
    });
  }, []);

  const handleNext = () => {
    if (data.next) {
      const url = new URL(data.next);
      const cursor = url.searchParams.get("cursor");
      loadClippings({ cursor });
    }
  };

  const handlePrevious = () => {
    if (data.previous) {
      const url = new URL(data.previous);
      const cursor = url.searchParams.get("cursor");
      loadClippings({ cursor });
    }
  };

  return (
    <div className="container-news-stand">
      <div className="header-news-stand">
        <div className="left-news-stand">
          <img
            src={brand?.brand  || logoDefault}
            alt={brand?.company_name  ? `Logo ${brand.company_name }` : "Logo"}
            className="logo-news-stand"
          />
        </div>

        <div className="right-news-stand">
          <p className="welcome-news-stand">
            Bem-vindo(a), as notícias mais recentes já estão prontas para você.
          </p>
          <p className="date-news-stand">Clippings do dia {formattedDate}.</p>
        </div>
      </div>

      <div className="body-news-stand">
          <ClickableNewsList
            items={data.results}
            showCursor={true}
            next={data.next}
            previous={data.previous}
            onNext={handleNext}
            onPrevious={handlePrevious}
          />
      </div>
      {isLoading && <Loading />}
    </div>
  );
}

export default NewsStand;
